import { useParams, Link } from "react-router-dom";
import { POLICIES, POLICY_NAV } from "@/lib/policies";

export default function Policy() {
  const { slug } = useParams();
  const doc = POLICIES[slug];

  if (!doc) {
    return <div className="py-32 text-center text-neutral-400">Policy not found. <Link to="/" className="text-[#D4AF37]">Home</Link></div>;
  }

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid lg:grid-cols-[240px_1fr] gap-10">
        <aside className="lg:sticky lg:top-24 h-fit">
          <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-4">Legal</p>
          <nav className="space-y-1">
            {POLICY_NAV.map(([s, label]) => (
              <Link key={s} to={`/policy/${s}`} data-testid={`policy-nav-${s}`}
                className={`block px-3 py-2 text-sm border-l-2 transition-colors ${s === slug ? "border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/5" : "border-transparent text-neutral-400 hover:text-white"}`}>
                {label}
              </Link>
            ))}
          </nav>
        </aside>

        <article data-testid="policy-content">
          <h1 className="font-display text-4xl font-bold">{doc.title}</h1>
          <p className="mt-2 text-sm text-neutral-500 font-mono">Last updated: {doc.updated}</p>
          <div className="mt-10 space-y-8">
            {doc.sections.map((s) => (
              <section key={s.h}>
                <h2 className="font-display text-xl font-semibold text-white">{s.h}</h2>
                {s.p && <p className="mt-2 text-neutral-300 leading-relaxed">{s.p}</p>}
                {s.list && (
                  <ul className="mt-3 space-y-2">
                    {s.list.map((li) => (
                      <li key={li} className="flex gap-2.5 text-neutral-300"><span className="text-[#D4AF37] mt-1">•</span>{li}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
          <p className="mt-12 text-xs text-neutral-600 border-t border-white/10 pt-6">This document is provided for platform transparency and is not legal advice. Terms subject to legal review in your jurisdiction.</p>
        </article>
      </div>
    </div>
  );
}
